// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"327":"e61f01a4","330":"f4e0a201","1486":"c041fd00","5397":"891ec99d"}[chunkId] + ".chunk.css";
};